import React from 'react'
import styled from 'styled-components'
import { Flex, Box } from '@rebass/grid'

import { D, M } from '../breakpoints'
import { Text, BlogImg, CategoryText } from './blogComponents'
import { langs } from '../../langs'

const Entities = require('html-entities').XmlEntities

const maxCategoryTags = 2

export const H3 = styled.h3`
  color: #000;
  font-size: 18px;
  line-height: 26px;
  margin: 0 20px 5px 0;
`

const BlogPostCard = props => {
  const { featured_media, title, slug, date, categories } = props.post
  return (
    <Flex width={[1, props.width || 1 / 3]} mb={[10, 30]} pr={[0, 30]}>
      <Box width={1} style={{ cursor: 'pointer' }}>
        <a
          href={`${langs[props.lang]}/blog/${slug}/`}
          style={{ textDecoration: 'none' }}
        >
          <D>
            <BlogImg
              style={{ maxWidth: 350, height: 135 }}
              media={featured_media}
            />
          </D>
          <M>
            <BlogImg media={featured_media} />
          </M>
          <CategoryText style={{ minHeight: 32 }}>
            {categories.slice(0, maxCategoryTags).map((e, i) => {
              if (i + 1 != categories.slice(0, maxCategoryTags).length) {
                return `${e.name}, `
              } else {
                return e.name
              }
            })}
          </CategoryText>
          <H3>{Entities.decode(title)}</H3>
          <Text
            style={{
              color: 'black',
              fontSize: 12,
              lineHeight: '16px',
            }}
          >
            {date}
          </Text>
        </a>
      </Box>
    </Flex>
  )
}

export default BlogPostCard
